import { Typography, CircularProgress, Grid, Box, useTheme } from "@mui/material";
import AssetMediaDisplay from "../components/asset/AssetMediaDisplay";
import ArchivedBanner from "../components/asset/ArchivedBanner";
import AssetIdEditModal from "../components/asset/AssetIdEditModal";
import { useAsset, AssetProvider } from "../context/AssetContext";
import AssetHeader from "../components/asset/AssetHeader";
import AssetSidebar from "../components/asset/AssetSidebar";
import AssetErrors from "../components/asset/AssetErrors";
import EditAssetModal from "../components/asset/EditAssetModal";

const AssetPageContent: React.FC = () => {
  const theme = useTheme();

  const {
    loading, asset
  } = useAsset();

  if (loading) {
    return <CircularProgress sx={{ position: 'absolute', top: '50%', left: '50%' }} />;
  }

  if (!asset) {
    return <Typography variant="h6" sx={{ textAlign: 'center', mt: 4 }}>Asset not found</Typography>;
  }

  const hasArchivedBanner = asset.archived === true;
  const CONTENT_MAX_HEIGHT = `calc(100vh - ${150 + (hasArchivedBanner ? 50 : 0)}px)`;

  return (
    <Box sx={{ backgroundColor: theme.palette.background.default, color: theme.palette.text.primary, p: 3 }}>
      {hasArchivedBanner && <ArchivedBanner />}

      <AssetHeader />

      <AssetIdEditModal />
      <EditAssetModal />

      <Grid container sx={{ maxHeight: CONTENT_MAX_HEIGHT, overflow: 'auto' }}>
        <Grid item xs={12} md={3} sx={{ maxHeight: CONTENT_MAX_HEIGHT, overflowY: "auto" }}>
          <AssetSidebar />
        </Grid>
        <Grid item xs={12} md={9} sx={{ maxHeight: CONTENT_MAX_HEIGHT, overflowY: "auto", p: 3 }}>
          <AssetMediaDisplay />
          <AssetErrors />
        </Grid>
      </Grid>
    </Box>
  );
};

// --- The final exported component that wires everything together ---
const AssetPage: React.FC = () => {
  return (
    <AssetProvider>
      <AssetPageContent />
    </AssetProvider>
  );
};

export default AssetPage;